<template>
	<th class="py-4 text-left truncate first:pl-4 last:pr-4 px:2" @click="$emit('click', $event)">
		<slot />
	</th>
</template>

<script>
export default {
	name: 'HeaderColumn',
};
</script>
